import React, { useState } from 'react'
import { useParams } from 'react-router-dom' 
import "./animate.css";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const ForgetPassword = () => {

    const [email,setEmail] = useState<string>();
    
    const [message,setMessage] = useState<string>("");
    const navigate = useNavigate();

 

    const handleResetPassword = async ()=>{
        debugger;
            const response:any = await axios.post("https://localhost:5001/ResetPassword/Index",{"Email":email});
           // console.log("EmailReset",response);
                debugger;
            if(response.data=="1"){
                setMessage("Sorry, Email address does not exists.Please try again.")
            }else if(response.data =="2"){
                setMessage("Mail sent succesfully");
                setEmail("");


            }else{
                setMessage("Something Went Wrong.")
            }

    }
   
  return (
    <div className="login_bg">
    <section className="login_section">
    <div className="container">
        <div className="row justify-content-center col-lg-12">
            <div className="col-lg-5 center_mode">
                <div className="lhs_grid wow animate__animated animate__fadeInLeft" data-wow-duration="2s" data-wow-delay=".6s">
                    <button onClick={()=>navigate("/")} className="btn_back"><i className="fa fa-angle-left"></i></button>
                    <h3>Hello ! <br/> <span id="gm">Good Morning</span></h3>

                    <h4><span>Reset</span> your account password</h4>

                    <div className="form-group">
                        <label><img src="images/icons/007-email.png"/></label>  
                        <input id="email" type="text" value={email} name="email" className="form-control" placeholder="Enter your email address" onChange={(e:any)=>{setEmail(e.target.value);setMessage("")}}/>
                    </div>
                    
                    <div className="text-center">
                        <button id="btn" className="btn_login" onClick={handleResetPassword}><img src="images/icons/008-enter.png"/> Reset Password</button>
                    </div>
                    <div className='text-center mt-2'>
                     <p className='text-danger'> {message?message:""} </p>

                    </div>
                    <div className="apps_grid text-center mobile_apps_grid">
                        <p>Available on:</p>
                        <a href="https://play.google.com/store/apps/details?id=com.prosares.wow_mobile"><img className="android-img" src="images/google-play-badge-en.png" alt=""/></a>
                        <a href="https://apps.apple.com/us/app/prosares-wow/id1644326812"><img className="apple-img" src="images/app_Store.png" alt=""/></a>
                    </div>
                </div>
            </div>
            <div className="col-lg-6">
                <div className="rhs_grid wow animate__animated animate__fadeInRight" data-wow-duration="2s" data-wow-delay=".6s">
                    <div className="top_head text-center">
                        <img src="images/logo.png" alt="" className="pro-logo"/>
                        <h3>Welcome to <br/> <span>WOW Portal</span></h3>
                        <div className="apps_grid desktop_apps_grid">
                            <p>Available on:</p>
                            <a href="https://play.google.com/store/apps/details?id=com.prosares.wow_mobile"><img className="android-img" src="images/google-play-badge-en.png" alt=""/></a>
                            <a href="https://apps.apple.com/us/app/prosares-wow/id1644326812"><img className="apple-img" src="images/app_Store.png" alt=""/></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
</div>
  )
}

export default ForgetPassword;
